import React, { Component } from 'react';
import './Html.css';

class Html extends Component {
  render() {
    const { html } = this.props.contentBlock;

    return (
      <div className={'html'}>
        <div dangerouslySetInnerHTML={{__html: html}}>
        </div>
      </div>
    );
  }
}

export default Html;



// WEBPACK FOOTER //
// ./src/components/content-blocks/Html/Html.js